import { render } from "./profile_subscribe.vue?vue&type=template&id=0dddd90d"
import script from "./profile_subscribe.vue?vue&type=script&lang=js"
export * from "./profile_subscribe.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/user/profile/tabs/profile_subscribe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dddd90d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dddd90d', __exports__)) {
    console.log('reload')
    api.reload('0dddd90d', __exports__)
  }
  
  module.hot.accept("./profile_subscribe.vue?vue&type=template&id=0dddd90d", () => {
    console.log('re-render')
    api.rerender('0dddd90d', render)
  })

}


export default __exports__